/**
 * Date/time formatting helpers. Event times are stored as ISO8601 UTC and
 * always displayed to users in America/Chicago local time, per project
 * requirements, regardless of the visitor's own device timezone.
 */
const CHICAGO_TZ = "America/Chicago";

export function formatEventDateTime(isoUtc) {
  if (!isoUtc) return "";
  const date = new Date(isoUtc);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("en-US", {
    timeZone: CHICAGO_TZ,
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(date);
}

export function formatEventDate(isoUtc) {
  if (!isoUtc) return "";
  const date = new Date(isoUtc);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("en-US", {
    timeZone: CHICAGO_TZ,
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(date);
}

export function formatEventTimeRange(startIsoUtc, endIsoUtc) {
  if (!startIsoUtc) return "";
  const start = new Date(startIsoUtc);
  const timeFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: CHICAGO_TZ,
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  });
  if (!endIsoUtc) return timeFormatter.format(start);
  const end = new Date(endIsoUtc);
  const startNoTz = new Intl.DateTimeFormat("en-US", {
    timeZone: CHICAGO_TZ,
    hour: "numeric",
    minute: "2-digit",
  }).format(start);
  return `${startNoTz} \u2013 ${timeFormatter.format(end)}`;
}

export function isPastEvent(isoUtc) {
  const date = new Date(isoUtc);
  return date.getTime() < Date.now();
}
